import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';

export function AuthCallback(): JSX.Element {
  const auth = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (auth?.isAuthenticated) nav('/', { replace: true });
  }, [auth?.isAuthenticated, nav]);

  if (auth?.error) return <div style={{ padding: 30 }}>サインインに失敗しました: {auth.error.message}</div>;
  return <div style={{ padding: 30 }}>サインイン中…</div>;
}
